import { render, staticRenderFns } from "./ConfigurarAlertaForm.vue?vue&type=template&id=2a745346&scoped=true&"
import script from "./ConfigurarAlertaForm.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarAlertaForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarAlertaForm.vue?vue&type=style&index=0&id=2a745346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a745346",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2a745346', component.options)
    } else {
      api.reload('2a745346', component.options)
    }
    module.hot.accept("./ConfigurarAlertaForm.vue?vue&type=template&id=2a745346&scoped=true&", function () {
      api.rerender('2a745346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Alertas/ConfigurarAlertaForm.vue"
export default component.exports